//
// Generated class AdyenProxyPaymentTransaction
//

/// <reference path="AdyenProxyPaymentTransaction_ManagedObject.ts" />

class AdyenProxyPaymentTransaction extends AdyenProxyPaymentTransaction_ManagedObject
{

}
